import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login.vue'
import Register from '../components/Register.vue'
import Userhome from '../page/user/Userhome.vue'
import usersuc_sq1 from '../page/user/usersuc_sq1.vue'
// import usersuc_sq2 from '../page/user/usersuc_sq2.vue'
import usersuc_sq3 from '../page/user/usersuc_sq3.vue'
import usersplist from '../page/user/usersplist.vue'
import userspinfo from '../page/user/userspinfo.vue'
import userspedit from '../page/user/userspedit.vue'
import pro_list from '../page/pro_list.vue'
import pro_info from '../page/pro_info.vue'
import help_list from '../page/help_list.vue'
import help_info from '../page/help_info.vue'
import store from '../store/index'
Vue.use(Router)

const router = new Router({
  routes: [

    {
      path: '/',
      redirect:'/user/userhome',
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/login',
      component: Login
    }  ,
    {
      path: '/register',
      component: Register
    },
    {
      path:'/user/userhome',
      component:Userhome,
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path:'/user/usersuc_sq1',
      component:usersuc_sq1,
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    // {
    //   path:'/user/usersuc_sq2',
    //   component:usersuc_sq2,
    //   meta: {
    //     requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
    //   }
    // },
    {
      path:'/user/usersuc_sq3',
      component:usersuc_sq3,
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path:'/user/usersplist',
      component:usersplist,
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      name:'sqDetail',
      path:'/user/usersplist/userspinfo',
      component:userspinfo,
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      name:'edit_sp',
      path:'/user/usersplist/userspedit',
      component:userspedit,
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path:'/pro_list',
      component:pro_list
    },
    {
      name: "gsDetail",
      path:'/pro_list/pro_info',
      component:pro_info
    }
    ,
    {
      path:'/help_list',
      component:help_list
    },
    {
      name: "helpDetail",
      path:'/help_list/help_info',
      component:help_info
    }


  ]
})


// 注册全局钩子用来拦截导航
router.beforeEach((to, from, next) => {
  const token = store.state.token
  // console.log(token)
  if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
    if (token) { // 通过vuex state获取当前的token是否存在
      next()
    } else {
      console.log('该页面需要登陆')
      next({
        path: '/login'
        // query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js